import { Guide, HelpGuideCardProps } from 'appJS/components/HelpGuideCard';
import * as translations from './strings';
import { getLangKey } from '../../../../javascript/models/Language';
import { getGuideLink } from 'appJS/utils/HelpArticleButton';
const strings = translations[getLangKey()];

type HelpGuidesProps = {
  aiSettings?: {
    onHideGuide: () => void;
  };
};

export const helpGuides = (
  props?: HelpGuidesProps
): { [key: string]: HelpGuideCardProps } => {
  const workflowLink = getGuideLink({
    articleKey: 'defineYourWorkflow',
    text: strings.bestWorkflow
  });
  const installLink = getGuideLink({ articleKey: 'installingBugherd' });
  const clientFeedbackLink = getGuideLink({
    articleKey: 'clientFeedbackTips'
  });
  const aiSettingsLink = getGuideLink({ articleKey: 'bugherdAI' });

  return {
    integrations: {
      guide: Guide.IntegrationSettings,
      header: strings.integrationsGuideHeader,
      message: strings.integrationsGuideDescription,
      links: [
        workflowLink,
        {
          text: strings.setItUp,
          link: '/collections/12945768-integrations',
          articleId: 12945768
        }
      ],
      divider: true,
      isAdminView: true
    },
    install: {
      guide: Guide.InstallSettings,
      header: strings.installingBugherd,
      message: strings.installMethod,
      guideButton: installLink,
      isAdminView: true
    },
    clientPermissions: {
      guide: Guide.ClientPermissionSettings,
      header: strings.clientFeedbackTipsHeader,
      message: strings.clientFeedbackTipsDescription,
      guideButton: clientFeedbackLink,
      isAdminView: true
    },
    aiSettings: {
      guide: Guide.AISettings,
      header: strings.aiHelpWithHeader,
      guideButton: aiSettingsLink,
      isAdminView: true,
      onHideGuide: props?.aiSettings?.onHideGuide
    }
  };
};
